import { Link, useParams } from 'react-router';
import type { CanonicalStage } from '@capture/shared';
import {
  STAGE_DEEP_LINKS,
  type DeepLink,
  type DeepLinkSurface,
} from '../stage-deep-links';
import './StageDeepLinks.css';

interface Props {
  stage: CanonicalStage;
}

// WU-10 / R-130 — `processing` is the internal surface identifier; the
// operator-facing label was renamed from "Processing Config" to "Job Config"
// to keep the noun continuous with the Job Types entry point.
const SURFACE_LABEL: Record<DeepLinkSurface, string> = {
  form: 'Form Config',
  processing: 'Job Config',
  admin: 'Admin',
};

const CURRENT_SURFACE: DeepLinkSurface = 'form';

export function StageDeepLinks({ stage }: Props) {
  const { jobTypeId = '' } = useParams<{ jobTypeId: string }>();
  const links = STAGE_DEEP_LINKS[stage];
  if (!links || links.length === 0) return null;

  return (
    <section className="sdl-section">
      <div className="sdl-heading">Configure this stage in:</div>
      {links.map((link) => (
        <DeepLinkRow key={link.label} link={link} jobTypeId={jobTypeId} />
      ))}
    </section>
  );
}

function DeepLinkRow({ link, jobTypeId }: { link: DeepLink; jobTypeId: string }) {
  return (
    <div className="sdl-row">
      <span className="sdl-row-label" data-testid="sdl-row-label">
        {link.label}
      </span>
      <span className="sdl-row-divider" aria-hidden>
        ·
      </span>
      {link.status === 'available' && link.href && link.destination ? (
        <Link to={link.href(jobTypeId)} className="rb-btn">
          {link.surface !== CURRENT_SURFACE
            ? `${SURFACE_LABEL[link.surface]} / ${link.destination} →`
            : `${link.destination} →`}
        </Link>
      ) : (
        <span className="sdl-coming-soon">coming soon</span>
      )}
    </div>
  );
}
